



















































































































import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import FormCode from "@/common/components/organisms/FormCode.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";
import FormUneditableText from "@/common/components/atoms/FormUneditableText.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max, confirmed } from "vee-validate/dist/rules";
import { Vue, Component, Watch } from "vue-property-decorator";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

//API call
import { myPageEmailReset } from "@/general/store/api";

import commons from "@/common/store/modules/commons";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

extend("max", {
  ...max,
  message: "{_field_}は{length}文字以内を入力してください。"
});

extend("confirmed", {
  ...confirmed,
  message: "{_field_}が一致しません。"
});

extend("code_4", {
  message(field) {
    return `${field}を入力してください。`;
  },
  validate(value) {
    if (value.length === 4) {
      return true;
    }
    return false;
  }
});

extend("code_num", {
  validate: (value: any) => {
    if (value.match(/[^\d]/)) return false;
    return true;
  },
  message: "{_field_}は数字のみ入力可能です。"
});

extend("code_sameall", {
  validate: (value: any) => {
    if (value.length === 4) {
      const validValue = value.replace(/(\d)\1+/, "");
      if (validValue.length === 0) return false;
    }
    return true;
  },
  message: "同数字（1111等）はセキュリティ上設定いただけません。"
});

extend("code_serial", {
  validate: (value: any) => {
    if (value.length === 4) {
      const firstNumber = parseInt(value.charAt(0), 10);
      let ascValue = "";
      let descValue = "";
      for (let i = 0; i < 4; i++) {
        let newAscNumber = firstNumber + i;
        let newDescNumber = firstNumber - i;
        if (newAscNumber >= 10) newAscNumber -= 10;
        if (newDescNumber >= 10) newDescNumber -= 10;
        if (newAscNumber < 0) newAscNumber += 10;
        if (newDescNumber < 0) newDescNumber += 10;
        ascValue += String(newAscNumber);
        descValue += String(newDescNumber);
      }
      if (value === ascValue || value === descValue) return false;
    }
    return true;
  },
  message: "連続した数字4桁（1234等）はセキュリティ上設定いただけません。"
});

@Component({
  components: {
    TheTemplateM,
    InputText,
    ButtonMain,
    FormCode,
    FormLabel,
    FormUneditableText,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  }
})
export default class MyPageEmailSettings extends Vue {
  $refs!: {
    form: HTMLFormElement;
    codeValidationProvider: HTMLFormElement;
  };

  step = 1;
  stepOptions: any = [
    { step: 1, label: "入力" },
    { step: 2, label: "メール確認" },
    { step: 3, label: "本人認証" },
    { step: 4, label: "完了" }
  ];
  newEmail = "";
  newEmailConfirm = "";
  code = "";
  currentAndNewEmailIsSame = false;
  currentAndNewEmailIsSameError =
    "既存のメールアドレスと新しいメールアドレスを同じにすることはできません";

  userInfo: any = {};
  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "メールアドレス変更",
      url: "",
      pageType: "lower"
    }
  ];

  get currentEmail() {
    return this.userInfo?.email;
  }

  @Watch("newEmail")
  onChangeNewEmail() {
    if (this.currentEmail == this.newEmail) {
      this.currentAndNewEmailIsSame = true;
    } else {
      this.currentAndNewEmailIsSame = false;
    }
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    commons.getBreadcrumb(this.breadcrumb);
    this.userInfo = JSON.parse(LocalStorage.getItem("userDetails") as string);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (
      urlParams.get("back_from") &&
      urlParams.get("back_from") == "email_confirmation"
    ) {
      this.newEmail = LocalStorage.getItem("new_email")
        ? (LocalStorage.getItem("new_email") as string)
        : "";
      this.newEmailConfirm = LocalStorage.getItem("new_email")
        ? (LocalStorage.getItem("new_email") as string)
        : "";
    }
  }

  async submit() {
    const OrgSpecificData = LocalStorage.getItem("OrgSpecificData") as string;
    const org = JSON.parse(OrgSpecificData);

    const page_title = org.page_title;

    const emailReset: any = await myPageEmailReset({
      email: this.newEmail,
      auth_code: this.code,
      page_title: page_title
    });

    LocalStorage.setItem("new_email", this.newEmail);
    LocalStorage.setItem("code", this.code);

    if (emailReset && emailReset.id) {
      location.href = "/my-page/email-confirmation/";
    }
  }

  setCode(code: string) {
    this.code = code;
    this.$nextTick(function() {
      this.$refs.codeValidationProvider.validate();
    });
  }
}
